<template>
  <div>
    <form id="formSiteSetupClientConfig" @change="clearErrors()" class="d-flex flex-column" v-on:submit.prevent="updateClientConfigurationSiteSettings">
      <div class="d-flex flex-column tab-card-form">
        <div class="element-info">
          <div class="row align-items-center">
            <div v-if="this.mobile" class="col-sm-8">
              <div class="element-info-with-icon justify-content-center">
                <div class="element-info-text text-center">
                  <h5 class="element-inner-header">Client Configuration</h5>
                  <div class="element-inner-desc">Here you can change the client configurations.</div>
                </div>
              </div>
            </div>
            <div v-else class="col-sm-8">
              <div class="element-info-with-icon">
                <div class="element-info-icon">
                  <fontAwesomeIcon :icon="['fas', 'user-edit']" size="2x" />
                </div>
                <div class="element-info-text ml-5">
                  <h5 class="element-inner-header">Client Configuration</h5>
                  <div class="element-inner-desc">Here you can change the client configurations.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
				<div class="project-box d-flex flex-column">
          <div class="project-head">
            <div class="project-title">
              <h5 v-if="!this.mobile" class="py-2 element-header">Login</h5>
              <h5 v-else class="py-2 text-center">Login</h5>
            </div>
          </div>
					<div class="row">
						<b-form-group class="mt-3 col-lg-6 col-sm-12">
							<b-input-group>
								<b-input-group-prepend class="col-lg-6 col-sm-6 p-0">
										<b-input-group-text slot="prepend" class="col-12 pretext">
											<span class="pretext-span">Maximum login attempts</span>
										</b-input-group-text>
								</b-input-group-prepend>
								<b-form-input required v-model="clientConfigSettings.max_login_attempts"></b-form-input>
							</b-input-group>
						</b-form-group>
						<b-form-group class="mt-3 col-lg-6 col-sm-12">
							<b-input-group>
								<b-input-group-prepend class="col-lg-6 col-sm-6 p-0">
										<b-input-group-text slot="prepend" class="col-12 pretext">
											<span class="pretext-span">Maximum days of inactivity</span>
										</b-input-group-text>
								</b-input-group-prepend>
								<b-form-input required v-model="clientConfigSettings.max_days_of_inactivity"></b-form-input>
							</b-input-group>
						</b-form-group>
					</div>
					<div class="row">
						<b-form-group class="mt-3 col-lg-6 col-sm-12">
              <div v-if="this.mobile" slot="description">
                <p>This will be sent when a password hint is requested.
                The following placeholders can be used:
                </p>
              </div>
              <b-input-group>
                <b-input-group-prepend class="col-lg-6 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Allowed IP addresses</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <b-form-textarea v-if="this.mobile" class="txtbox-min-h" v-model="clientConfigSettings.clientAllowedIpAddresses"></b-form-textarea>
                <b-form-textarea v-else id="clientAllowedIpAddresses" class="txtbox-min-h" v-model="clientConfigSettings.clientAllowedIpAddresses"></b-form-textarea>
                <b-popover target="clientAllowedIpAddresses" triggers="focus" title="Tip">
                  <div class="text-size-small">
                    <p>Separate multiple IP addresses with a comma
                    </p>
                  </div>
                </b-popover>
              </b-input-group>
							<ResponseInfo v-if="getResponseInfo.arrayResponses" responseFlag="invalidIpAddress" class="mb-1 mt-1"/>
            </b-form-group>
						<b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-6 col-sm-6 p-0">
                  <b-input-group-text slot="prepend" class="col-12 pretext">
                    <span class="pretext-span">Profile icon colour</span>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input class="text-uppercase" v-model="clientConfigSettings.profile_icon_color"></b-form-input>
								<b-input-group-append>
									<b-form-input type="color" class="d-inline-block h-auto p-0 color-picker" v-model="clientConfigSettings.profile_icon_color"></b-form-input>
								</b-input-group-append>
              </b-input-group>
            </b-form-group>
					</div>
				</div>
				<div class="project-box d-flex flex-column">
          <div class="project-head">
            <div class="project-title">
              <h5 v-if="!this.mobile" class="py-2 element-header">Password</h5>
              <h5 v-else class="py-2 text-center">Password</h5>
            </div>
          </div>
					<div class="row">
						<b-form-group class="mt-3 col-lg-4 col-sm-12">
							<b-input-group>
								<b-form-checkbox
									v-model="clientConfigSettings.clientPasswordRequireCapital"
									name="splitter_management"
									:value="1"
									:unchecked-value="0">
									Password requires a capital letter
								</b-form-checkbox>
							</b-input-group>
						</b-form-group>
						<b-form-group class="mt-3 col-lg-4 col-sm-12">
							<b-input-group>
								<b-form-checkbox
									v-model="clientConfigSettings.clientPasswordRequireSpecial"
									name="show_activity_dashboard"
									:value="1"
									:unchecked-value="0">
									Password requires a special character
								</b-form-checkbox>
							</b-input-group>
						</b-form-group>
						<b-form-group class="mt-3 col-lg-4 col-sm-12">
							<b-input-group>
								<b-form-checkbox
									v-model="clientConfigSettings.clientPasswordRequireDigit"
									name="show_activity_dashboard"
									:value="1"
									:unchecked-value="0">
									Password requires at least one digit
								</b-form-checkbox>
							</b-input-group>
						</b-form-group>
					</div>
					<div class="row">
						<b-form-group class="mt-3 col-lg-6 col-sm-12">
							<b-input-group>
								<b-input-group-prepend class="col-lg-6 col-sm-6 p-0">
										<b-input-group-text slot="prepend" class="col-12 pretext">
											<span class="pretext-span">Password reset interval</span>
										</b-input-group-text>
								</b-input-group-prepend>
								<b-form-input required v-model="clientConfigSettings.password_reset_interval"></b-form-input>
							</b-input-group>
						</b-form-group>
						<b-form-group class="mt-3 col-lg-6 col-sm-12">
							<b-input-group>
								<b-input-group-prepend class="col-lg-6 col-sm-6 p-0">
										<b-input-group-text slot="prepend" class="col-12 pretext">
											<span class="pretext-span">Minimum password length</span>
										</b-input-group-text>
								</b-input-group-prepend>
								<b-form-input required v-model="clientConfigSettings.clientMinPasswordLength"></b-form-input>
							</b-input-group>
						</b-form-group>
					</div>
					<div class="row">
						<b-form-group class="mt-3 col-lg-6 col-sm-12">
							<b-input-group>
								<b-input-group-prepend class="col-lg-6 col-sm-6 p-0">
										<b-input-group-text slot="prepend" class="col-12 pretext">
											<span class="pretext-span">Maximum password length</span>
										</b-input-group-text>
								</b-input-group-prepend>
								<b-form-input required v-model="clientConfigSettings.clientMaxPasswordLength"></b-form-input>
							</b-input-group>
						</b-form-group>
					</div>
				</div>
				<div class="project-box d-flex flex-column">
          <div class="project-head">
            <div class="project-title">
              <h5 v-if="!this.mobile" class="py-2 element-header">General</h5>
              <h5 v-else class="py-2 text-center">General</h5>
            </div>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-form-checkbox
                    v-model="clientConfigSettings.invoice_compliance"
                    name="invoice_compliance"
                    :value="1"
                    :unchecked-value="0">
                  Invoice compliance
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-6 col-sm-6 p-0">
                  <b-input-group-text slot="prepend" class="col-12 pretext">
                    <span class="pretext-span">Country list</span>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-select v-model="selected" :options="countries" :select-size="4" multiple ></b-form-select>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-6 col-sm-6 p-0">
                  <b-input-group-text slot="prepend" class="col-12 pretext">
                    <span class="pretext-span">Admin's email</span>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-model="clientConfigSettings.admin_email"></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-6 col-sm-6 p-0">
                  <b-input-group-text slot="prepend" class="col-12 pretext">
                    <span class="pretext-span">Select the format of the date</span>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-select v-model="firstDateInput" class="text-capitalize" :options="options">
                </b-form-select>
                <b-form-select v-model="secondDateInput" class="text-capitalize" :options="options">
                </b-form-select>
                <b-form-select v-model="thirdDateInput" class="text-capitalize" :options="options">
                </b-form-select>
              </b-input-group>
              <ResponseInfo v-if="getResponseInfo.arrayResponses" responseFlag="invalidFormatDate" class="mb-1 mt-1"/>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-6 col-sm-6 p-0">
                  <b-input-group-text slot="prepend" class="col-12 pretext">
                    <span class="pretext-span">Delivery Reports Export Limit</span>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input required v-model="clientConfigSettings.delivery_export_limit"></b-form-input>
              </b-input-group>
            </b-form-group>
            <!-- NS-10044 added dynamic document download limit, PW -->
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-6 col-sm-6 p-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext">
                      <span class="pretext-span">Documents Download Limit</span>
                    </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input required v-model="clientConfigSettings.max_documents_download"></b-form-input>
              </b-input-group>
            </b-form-group>
            <!-- NS-9909 client can specify how many widgets they want to see on dashboard, VS -->
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-6 col-sm-6 p-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext">
                      <span class="pretext-span">Dashboard Widgets Limit</span>
                    </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-model="clientConfigSettings.max_dashboard_widgets" type="number" max="4" min="0"></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-6 col-sm-6 p-0">
                  <b-input-group-text slot="prepend" class="col-12 pretext">
                    <span class="pretext-span">General Currency Symbol</span>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-model="clientConfigSettings.general_currency_symbol" type="text" maxlength="3"></b-form-input>
              </b-input-group>
            </b-form-group>
            <!-- EIPP-602 Enabled/disable link to redirect to V1, PW -->
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-form-checkbox
                    v-model="clientConfigSettings.v1_redirection_enabled"
                    name="v1_redirection_enabled"
                    :value="1"
                    :unchecked-value="0">
                  Enabled V1 Redirection Link
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
          </div>
        </div>
        <div class="project-box d-flex flex-column">
          <div class="project-head">
            <div class="project-title">
              <h5 v-if="!this.mobile" class="py-2 element-header">Email</h5>
              <h5 v-else class="py-2 text-center">Email</h5>
            </div>
          </div>
          <div class="row">
            <!-- EIPP-577 customise email notification sent to a user who changed password , IS  -->
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-6 col-sm-6 p-0">
                  <b-input-group-text slot="prepend" class="col-12 pretext">
                    <span class="pretext-span">Display email</span>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-model="clientConfigSettings.admin_display_sender_email"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
        </div>
        <!-- EIPP-715 Moved integration related fields from advanced to here, PW -->
        <div class="project-box d-flex flex-column">
          <div class="project-head">
            <div class="project-title">
              <h5 v-if="!this.mobile" class="py-2 element-header">Integration</h5>
              <h5 v-else class="py-2 text-center">Integration</h5>
            </div>
          </div>
          <div class="row">
            <!-- EIPP-715, Moved integration related fields  -->
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-form-checkbox
                  v-model="clientConfigSettings.enable_supply_chain_finance"
                  name="enable_supply_chain_finance"
                  :value="1"
                  :unchecked-value="0">
                  Enable Supply Chain Finance
                </b-form-checkbox>
              </b-input-group>
              <template v-if="clientConfigSettings.enable_supply_chain_finance && clientConfigSettings.enable_supply_chain_finance == '1'">
                <div class="row mt-2">
                  <b-input-group>
                    <b-input-group-prepend class="col-lg-6 col-sm-6 p-0">
                      <b-input-group-text slot="prepend" class="col-12 pretext">
                        <span class="pretext-span">Corcentric ID</span>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input class="col-6" required v-model="clientConfigSettings.corcentric_id"></b-form-input>
                  </b-input-group>
                </div>
              </template>
            </b-form-group>
          </div>
          <!-- EIPP-1021 Configurable endpoints, PW -->
          <div class="row">
            <template v-if="clientConfigSettings.enable_supply_chain_finance && clientConfigSettings.enable_supply_chain_finance == '1'">
              <b-form-group class="mt-3 col-lg-6 col-sm-12">
                <b-input-group>
                  <b-input-group-prepend class="col-lg-6 col-sm-6 p-0">
                      <b-input-group-text slot="prepend" class="col-12 pretext">
                        <span class="pretext-span">Managed AR Authentication Endpoint</span>
                      </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input v-model="clientConfigSettings.managed_ar_authentication_endpoint" required type="text"></b-form-input>
                </b-input-group>
              </b-form-group>
              <b-form-group class="mt-3 col-lg-6 col-sm-12">
                <b-input-group>
                  <b-input-group-prepend class="col-lg-6 col-sm-6 p-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext">
                      <span class="pretext-span">Managed AR Enrollment Endpoint</span>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input v-model="clientConfigSettings.managed_ar_enrollment_endpoint" required type="text"></b-form-input>
                </b-input-group>
              </b-form-group>
              <b-form-group class="mt-3 col-lg-6 col-sm-12">
                <b-input-group>
                  <b-input-group-prepend class="col-lg-6 col-sm-6 p-0">
                    <b-input-group-text slot="prepend" class="col-12 pretext">
                      <span class="pretext-span">Managed AR Dispute Endpoint</span>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input v-model="clientConfigSettings.managed_ar_dispute_endpoint" required type="text"></b-form-input>
                </b-input-group>
              </b-form-group>
            </template>
          </div>
          <ResponseInfo v-if="getResponseInfo.responseName == 'clientConfigurationUpdate'" class="mb-1 mt-1"/>
        </div>
        <button v-if="!this.mobile" class="btn btn-primary mt-3 align-self-end" type="submit" value="submit">Update</button>
        <button v-else class="btn btn-secondary mt-3 align-self-end" type="submit" value="submit">Update</button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import ValidationErrors from '@/components/ValidationErrors.vue'

export default {
	name: 'SiteSetupClientConfiguration',
	components: {
  	ResponseInfo,
    ValidationErrors
	},
	data() {
		return {
			setupClientConfig: {},
			mobile: window.innerWidth <= 700,
			dateArray: [],
			firstDateInput: null,
			secondDateInput: null,
			thirdDateInput: null,
      selected: null,
      countries: [
        { value: 'France', text: 'France' },
        { value: 'Germany', text: 'Germany' }
      ],
			options: [
				{ value: null, text: 'Select', disabled: true},
			  { value: 'DD', text: 'Day', disabled: false},
				{ value: 'MM', text: 'Month', disabled: false},
				{ value: 'YYYY', text: 'Year', disabled: false}
			],
			clientConfigSettings: {
				max_login_attempts: null,
				max_days_of_inactivity: null,
				clientAllowedIpAddresses: null,
				clientPasswordRequireCapital: null,
				clientPasswordRequireSpecial: null,
				clientPasswordRequireDigit: null,
				password_reset_interval: null,
				clientMinPasswordLength: null,
				clientMaxPasswordLength: null,
				admin_email: null,
        admin_display_sender_email: null ,
				profile_icon_color: null,
        delivery_export_limit: null,
        max_documents_download: null,
        max_dashboard_widgets: null,
        general_currency_symbol: null,
        invoice_compliance: null,
        invoice_compliance_countries: null
			}
		}
	},
	created() {
		this.$store.dispatch('getClientConfigurationSettings')
		.then(() => {
			this.clientConfigSettings = this.$store.getters.getClientConfigurationSettings
			this.dateArray = this.clientConfigSettings.date_picker_format
			this.dateArray = this.dateArray.split("-")
			this.firstDateInput = this.dateArray[0] ? this.dateArray[0] : null
			this.secondDateInput = this.dateArray[1] ? this.dateArray[1] : null
			this.thirdDateInput = this.dateArray[2] ? this.dateArray[2] : null

      this.selected = Object.values(JSON.parse(this.clientConfigSettings.invoice_compliance_countries))

      let hashTagCheck = this.clientConfigSettings.profile_icon_color.startsWith("#")
      if (!hashTagCheck) {
        this.clientConfigSettings.profile_icon_color = '#'+this.clientConfigSettings.profile_icon_color
      }

		})

	},
	computed:{
		...mapGetters(['allTemplateDetails', 'getUserDetails','getIsNewsnet', 'getClientConfigurationSettings', 'getResponseInfo', 'getValidationErrors']),
	},
	methods: {
		updateClientConfigurationSiteSettings() {
			this.clientConfigSettings.date_picker_format = this.firstDateInput+"-"+this.secondDateInput+"-"+this.thirdDateInput
      this.clientConfigSettings.invoice_compliance_countries = this.selected

			let hashTagCheck = this.clientConfigSettings.profile_icon_color.startsWith("#")
			if (hashTagCheck) {
        let profIconColourString = this.clientConfigSettings.profile_icon_color
				this.clientConfigSettings.profile_icon_color = profIconColourString.substring(1)
			}

			this.$store.dispatch('updateClientConfigurationSiteSettings',{
        data: this.clientConfigSettings
			}).then(() => {
				this.$store.commit('setProfileIconColour', this.clientConfigSettings.profile_icon_color)
        this.clientConfigSettings.profile_icon_color = '#'+this.clientConfigSettings.profile_icon_color

        // EIPP-602 Commit for redirect link, PW
        this.$store.commit('setRedirectionLink', this.clientConfigSettings.v1_redirection_enabled)
			})
		},
		clearErrors() {
      //clearing the error message when we change the input
      this.$store.commit('setValidationErrors', [])
		},
	}
}
</script>

<style lang="css" scoped>
.tab-card-form{
  min-width: 70%;
}
.txtbox-min-h{
  min-height: 150px;
}
.pretext{
  display: flex;
  align-items: center;
  justify-content: center;
}
.pretext-span{
  width: 100%;
  white-space: normal;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.color-picker{
  width: 40px;
}
.h-auto{
  height:auto;
}
</style>
